import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import Controls from "../../../controls/Controls";
import { useForm, Form } from "../../../controls/useForm";
import { request } from "../../../../api/Service";
import { store } from "../../../../redux-store/store";

const initialFValues = {
  id: 0,
  contactName: "",
  locationName: "",
  contactPhoneNumber: "",
  locationAddress: "",
  locationTypeId: "",
  dateCreated: new Date(),
  locationAddress2: "",
  locationContactAddress: "",
  locationDescription: "",
  zipcode: "",
};

export default function AddLocationForm(props) {
  const { addOrEdit, recordForEdit, cacNumber, userType } = props;
  const [states, setStates] = useState(
    store.getState().pickUpStationReducer.allStates
  );
  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    if ("locationAddress2" in fieldValues)
      temp.locationAddress2 = fieldValues.locationAddress2
        ? ""
        : "This field is required.";
    if ("zipcode" in fieldValues)
      temp.zipcode = fieldValues.zipcode ? "" : "This field is required.";
    if ("city" in fieldValues)
      temp.city = fieldValues.city ? "" : "This field is required.";
    if ("countryId" in fieldValues)
      temp.countryId = fieldValues.countryId !== "" ? "" : "Select a Country";
    if ("contactName" in fieldValues)
      temp.contactName = fieldValues.contactName
        ? ""
        : "This field is required.";
    if ("locationName" in fieldValues)
      temp.locationName = fieldValues.locationName
        ? ""
        : "This locationName is required.";
    if ("contactPhoneNumber" in fieldValues)
      temp.contactPhoneNumber = fieldValues.contactPhoneNumber
        ? ""
        : "This contactPhoneNumber is required.";
    if ("locationAddress" in fieldValues)
      temp.locationAddress = fieldValues.locationAddress ? "" : "Required";
    if ("locationTypeId" in fieldValues)
      temp.locationTypeId =
        fieldValues.locationTypeId !== "" ? "" : "Select a Location Type";
    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };
  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
    validate({ [name]: value });
    request("get", {}, `api/Admin/get-states-dropdown/${value}`).then(
      (data) => {
        console.log(data);
        setStates(data);
      }
    );
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, true, validate);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      var result = {
        ...values,
        companyId: store.getState().persistReducer.companyId,
      };
      addOrEdit(result, resetForm);
    }
  };

  useEffect(() => {
    if (recordForEdit !== null)
      setValues({
        ...recordForEdit,
      });
  }, [recordForEdit]);

  return (
    <Form onSubmit={handleSubmit}>
      <Grid container>
        <Grid item xs={6}>
          <Controls.Input
            name="name"
            label="Customer Name*"
            value={values.name || ""}
            readOnly={true}
            disabled={true}
            onChange={handleInputChange}
            error={errors.name}
          />
          <Controls.Input
            label="Zip Code*"
            name="zipCode"
            value={values.zipCode || ""}
            readOnly={true}
            disabled={true}
            onChange={handleInputChange}
            error={errors.zipCode}
          />
          <Controls.Input
            label="City*"
            name="city"
            value={values.city || ""}
            readOnly={true}
            disabled={true}
            onChange={handleInputChange}
            error={errors.city}
          />
          <Controls.Input
            label="Address Line 1*"
            name="address"
            readOnly={true}
            disabled={true}
            value={values.address || ""}
            onChange={handleInputChange}
            error={errors.address}
          />
          <Controls.Select
            name="countryId"
            label="Countries*"
            readOnly={true}
            disabled={true}
            value={values.countryId || ""}
            onChange={handleSelectChange}
            options={props.countries}
            error={errors.countryId}
          />

          <Controls.Checkbox
            label="Credit Customer*"
            name="creditCustomer"
            readOnly={true}
            disabled={true}
            value={values.creditCustomer}
            onChange={handleInputChange}
            error={errors.creditCustomer}
          />
        </Grid>
        <Grid item xs={6}>
          <Controls.Select
            name="stateId"
            label="State"
            readOnly={true}
            disabled={true}
            value={values.stateId || ""}
            onChange={handleInputChange}
            options={states}
            error={errors.stateId}
          />
          <Controls.Input
            label="Credit Amount"
            name="creditAmount"
            readOnly={true}
            disabled={true}
            value={values.creditAmount || ""}
            onChange={handleInputChange}
            error={errors.creditAmount}
          />

          <Controls.Input
            label="Approved By*"
            name="approvedBy"
            value={values.approvedBy || ""}
            readOnly={true}
            disabled={true}
            onChange={handleInputChange}
            error={errors.approvedBy}
          />
          <Controls.Input
            label="Date Approved*"
            type="date"
            name="dateApproved"
            readOnly={true}
            disabled={true}
            value={values.approvedBy || ""}
            onChange={handleInputChange}
            error={errors.approvedBy}
          />
          <Controls.Input
            label="Is Active*"
            name="isActive"
            readOnly={true}
            disabled={true}
            value={values.isActive || ""}
            onChange={handleInputChange}
            error={errors.isActive}
          />
          <Controls.Input
            label="Date Created*"
            name="dateCreated"
            value={values.dateCreated || ""}
            readOnly={true}
            disabled={true}
            onChange={handleInputChange}
            error={errors.dateCreated}
          />
          <Controls.Checkbox
            label="Credit Approved*"
            name="creditApproved"
            readOnly={true}
            disabled={true}
            value={values.creditApproved}
            onChange={handleInputChange}
            error={errors.creditApproved}
          />
          {/* <div>
            <Controls.Button disbaled={true} type="submit" text="Submit" />
          </div> */}
        </Grid>
      </Grid>
    </Form>
  );
}
